import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useUrlStorage = <T>(
  key: unknown | unknown[],
  initialValue?: T
) => {
  const { pathname } = useLocation();
  const queryClient = useQueryClient();
  const keyAsArray = Array.isArray(key) ? key : [key];
  const queryKey = [pathname, ...keyAsArray];

  const storedValue = queryClient.getQueryData<T>(queryKey);

  const [value, setValue] = useState<T | undefined>(
    storedValue ?? initialValue ?? undefined
  );

  useEffect(() => {
    queryClient.setQueryData(queryKey, value);
  }, [value]);

  return [value, setValue];
};

export default useUrlStorage;
